import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./Pages/Index"
import NotFound from "./Pages/NotFound";
import { useEffect } from "react";
import { getOrCreateUserId } from "@/lib/session";
import { sendEvent, sendCampgain } from "@/lib/googleSheet";
import TermsAndConditions from "./Pages/Terms-and-conditions";
import PrivacyPolicy from "./Pages/Privacy-policy";
const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    const userId = getOrCreateUserId();
    sendEvent(userId, "USER_LANDED").catch(() => { });

    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");
    const utmCampaign = params.get("utm_campaign");
    const utmContent = params.get("utm_content");
    // sendCampgain(userId, utmSource, utmMedium, utmCampaign, utmContent).catch(() => { });

  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />

            {/* Legal Routes */}
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;